<template>
  <modal
    :show.sync="show"
    body-classes="p-0"
    :modal-classes="`modal-xl ${$style.modalClasses}`">
    <card class="card-form mb-0">
      <template slot="header">
        <h2 class="modal-title">Update Item</h2>
      </template>
      <form
        ref="updateItem"
        class="mt-3 no-form-control"
        @submit.prevent="updateItem"
        autocomplete="off">
        <div class="row">
          <div
            class="col-12 flex-between"
            :class="$style.updateItemSection">
            <el-tooltip
              manual
              effect="light"
              :value="missingName">
              <base-input
                name="name"
                type="text"
                label="Name"
                v-model="item.name" />
              <label
                slot="content"
                class="error">Please enter a name.</label>
            </el-tooltip>
            <base-input
              name="Sku"
              type="text"
              label="Sku"
              v-model="item.sku" />
            <div>
              <label class="d-block">Quantity</label>
              <el-input-number
                v-model="item.qty"
                :min="1" />
            </div>
            <div>
              <label class="d-block">Status</label>
              <el-tooltip
                manual
                effect="light"
                :value="missingStatus">
                <el-select
                  class="select-primary"
                  v-model="item.status"
                  placeholder="Select status">
                  <el-option
                    class="select-primary"
                    v-for="option in detailStatusOptions"
                    :key="option"
                    :label="option"
                    :value="option" />
                </el-select>
                <label
                  slot="content"
                  class="error">Please select a status.</label>
              </el-tooltip>
            </div>
          </div>
        </div>
        <el-divider />
        <div :class="$style.actions">
          <base-button
            type="default"
            class="btn-fill"
            @click="$emit('update:show', false)">
            Cancel
          </base-button>
          <div :class="$style.right">
            <base-button
              id="updateItem"
              native-type="submit"
              type="primary"
              class="btn-fill">
              Done
            </base-button>
          </div>
        </div>
      </form>
    </card>
  </modal>
</template>

<script>
import { Modal } from 'src/components/UI';
import {
  InputNumber,
  Divider,
} from 'element-ui';

export default {
  name: 'EditOrder',
  components: {
    Modal,
    [Divider.name]: Divider,
    [InputNumber.name]: InputNumber,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    detailStatusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      missingName: false,
      missingStatus: false,
    };
  },
  methods: {
    noop() {},
    validateItem() {
      return new Promise((resolve, reject) => {
        if (!this.item.name) {
          this.missingName = true;
          reject();
        }
        if (!this.item.status) {
          this.missingStatus = true;
          reject();
        }
        resolve();
      });
    },
    async updateItem() {
      try {
        await this.validateItem();
        this.$emit('updateItem', this.item);
      } catch (error) {
        this.noop();
      }
    },
  },
  watch: {
    item(val) {
      if (val.name) {
        this.missingName = false;
      }
      if (val.status) {
        this.missingStatus = false;
      }
    },
  },
};
</script>

<style module lang="scss">
@import 'assets/sass/dashboard/custom/_variables.scss';
.modalClasses {
  min-width: 750px;
}
.actions {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.actions .right > *{
  margin-right: 10px;
  margin-left: 10px;
}
.sectionTitle {
  font-size: 18px;
  font-weight: 500;
  color: #303133;
}
.updateItemButton {
  align-self: flex-end;
  margin: 0px;
  width: 172px;
}

.updateItemSection > * {
  padding-right: 12px;
}
</style>

<style>
.el-select-dropdown__item {
  height: auto!important;
}
.el-tooltip__popper label {
  margin-bottom: 0px;
}
.no-form-control .form-control {
  margin-bottom: 0px!important;
}

.no-form-control .form-group {
  margin-bottom: 0px!important;
}
</style>
